document.querySelectorAll( '.big-slider' ).forEach( section => {
    const nextArrow = jQuery( section ).find( '.big-slider-next' );
    const prevArrow = jQuery( section ).find( '.big-slider-prev' );

    jQuery( section ).find( '.big-slider__slides' ).slick( {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '300px',
        arrows: true,
        rows: 0,
        prevArrow,
        nextArrow,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '200px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '50px',
                }
            },
            {
                breakpoint: 501,
                settings: {
                    centerPadding: '30px',
                }
            }
        ]
    } );
} );
